const regex24h = /^([01]\d|2[0-3]):[0-5]\d$/;
const regex12h = /^(0?[1-9]|1[0-2]):[0-5]\d\s?(AM|PM)$/i;

export const isValidTime = (time: string, format12h = false) => {
  return format12h ? regex12h.test(time) : regex24h.test(time);
};
